import { useState } from "react";
import { format, parse } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (s) => (s ? parse(s.slice(0, 10), "yyyy-MM-dd", new Date()) : undefined);

// value: "yyyy-MM-dd" (or "yyyy-MM-ddTHH:mm" with withTime)
export function DateField({ value = "", onChange, withTime = false, testId = "date-field", placeholder = "Choisir une date", className = "", fromYear, toYear }) {
  const [open, setOpen] = useState(false);
  const day = toDate(value);
  const time = withTime ? (value.slice(11, 16) || "09:00") : "";
  const emit = (d, t = time) => onChange(d ? format(d, "yyyy-MM-dd") + (withTime ? `T${t}` : "") : "");
  const year = new Date().getFullYear();
  return (
    <div className={`flex gap-2 ${className}`} data-testid={testId}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={`${testId}-trigger`} className="mr-input flex items-center gap-2 text-left min-w-0 flex-1">
            <CalendarDays size={16} className="shrink-0 text-mr-muted" />
            <span className={`truncate ${day ? "" : "text-mr-muted"}`}>{day ? format(day, "EEEE d MMMM yyyy", { locale: fr }) : placeholder}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-mr-surface border-mr-border" align="start" data-testid={`${testId}-calendar`}>
          <Calendar mode="single" locale={fr} weekStartsOn={1} selected={day} defaultMonth={day} captionLayout="dropdown-buttons"
            fromYear={fromYear || year - 90} toYear={toYear || year + 10}
            classNames={{ caption_dropdowns: "flex gap-1", caption_label: "hidden", dropdown: "mr-input h-8 py-0 px-1 text-sm", vhidden: "sr-only",
              day_selected: "bg-mr-accent text-mr-on-accent hover:bg-mr-accent", day_today: "border border-mr-accent", day: "h-10 w-10 sm:h-9 sm:w-9 p-0 rounded-[3px] hover:bg-mr-raised", head_cell: "w-10 sm:w-9 text-[0.75rem] text-mr-muted font-normal" }}
            onSelect={(d) => { emit(d); setOpen(false); }} />
        </PopoverContent>
      </Popover>
      {withTime && <input type="time" data-testid={`${testId}-time`} className="mr-input w-28 shrink-0 tabular" value={time} disabled={!day} onChange={(e) => emit(day, e.target.value || "09:00")} />}
      {day && <button type="button" aria-label="Effacer la date" data-testid={`${testId}-clear`} className="mr-btn-ghost px-2 shrink-0" onClick={() => onChange("")}><X size={15} /></button>}
    </div>
  );
}
